import React from "react"
import parse from "html-react-parser"

const CustomHeader = ({ text, variant }) => {
  if(variant === "h1") return <h1 className="font-black text-center mb-4 ">{parse(text)}</h1>
  if(variant === "h2") return <h2 className="font-black text-center mb-4 ">{parse(text)}</h2>
  if(variant === "h3") return <h3 className="font-black text-center mb-4 ">{parse(text)}</h3>
  if(variant === "h4") return <h4 className="font-black text-center mb-4 ">{parse(text)}</h4>
}

export default CustomHeader
